import { helper } from '@ember/component/helper';

import { sumOne } from 'rise-ui/utils/array.js';

export default helper(function sumHelper(params) {
  return params.reduce(sumOne);
});
